module.exports = __webpack_public_path__ + "imgs/instagram-white.9ae1de5fbbf0941a22eadc7830e1007e.svg";